module.exports = "https://web-assets.ifttt.com/packs/media/docs/custom_badges-e4afcdae.jpg";